<template>
  <div id="pagination" v-if="!isloading && totRecords > 0">
    <!-- Go To input -->
    <div v-if="showGoTo">
      <b>Go To:&nbsp;&nbsp;</b>
      <input
        type="number"
        style="width: 60px; border: 1px solid #000; border-radius: 10%; text-align: center;"
        min="1"
        :max="page_len"
        @keyup.enter="goTo($event.target.value)"
      />
    </div>

    <!-- Per-page selector -->
    <div v-if="showPerPage">
      <b>Showing:</b>
      [<span
        v-for="p in page"
        :key="p"
        @click="handlePerPage(p)"
        :class="perPageClass(p)"
      >{{ p }}</span>]
      results {{ startRecord }} to
      {{ parseInt(currentPage) === parseInt(lastPage) ? totRecords : lastRecord }}
      of {{ totRecords }} records
    </div>

    <!-- Basic results text when per-page selector hidden -->
    <div v-if="!showPerPage">
      <b>Showing:</b>
      results {{ startRecord }} to
      {{ parseInt(currentPage) === parseInt(lastPage) ? totRecords : lastRecord }}
      of {{ totRecords }} records
    </div>

    <!-- First page button -->
  <div @click="!isFirstPage && goToFirst()" :class="[isCurrentPageClass, isFirstPage ? 'disabled' : '']">
  [First]
</div>


    <!-- Prev button -->
    <div
      @click="!isFirstPage && paginate(-1)"
      :class="[isCurrentPageClass, isFirstPage ? 'disabled' : '']"
    >
      [Prev {{ perpage }}]
    </div>

    <!-- Page numbers -->
    <div>
      [<span
        v-for="(v, i) in getPages"
        :key="i"
        @click="parseInt(v) !== parseInt(currentPage) && getDataByPage(v)"
        :class="[
          parseInt(v) === parseInt(currentPage) ? 'disabled current-page' : 'notactivespan'
        ]"
      >{{ v }}</span>]
    </div>

    <!-- Next button -->
    <div
      @click="!isLastPage && handleNext()"
      :class="[getLastPageClass, isLastPage ? 'disabled' : '']"
    >
      [Next {{ perpage }}]
    </div>

    <!-- Last button -->
<div
  @click="!isLastPage && goToLast()"
  :class="[getLastPageClass, isLastPage ? 'disabled' : '']"
>
  [Last]
</div>

  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data: () => ({
    page: [10, 20, 30, 40, 50],
  }),
  props: [
    'isloading',
    'startRecord',
    'currentPage',
    'lastPage',
    'lastRecord',
    'totRecords',
    'isCurrentPageClass',
    'perpage',
    'getLastPageClass',
    'totPage',
    'getPages',
    'showPerPage',
    'showGoTo'
  ],
  computed: {
    page_len() {
      return Math.ceil(this.totRecords / this.perpage);
    },
    isLastPage() {
      return parseInt(this.currentPage) >= parseInt(this.lastPage);
    },
    isFirstPage() {
      return parseInt(this.currentPage) <= 1;
    }
  },
  methods: {
    handlePerPage(p) {
      this.$emit('handlePerPage', p);
    },
    handleNext() {
      if (!this.isLastPage) {
        this.paginate(+1);
      }
    },
    perPageClass(p) {
      return this.perpage === p ? '' : 'notactivespan';
    },
    activeText(n) {
      return parseInt(n) === parseInt(this.currentPage) ? 'disabled current-page' : 'notactivespan';
    },
    goTo(page) {
      if (page > this.page_len || page < 1) {
        this.$swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Page does not exist',
        });
      } else {
        this.getDataByPage(parseInt(page));
      }
    },
    getDataByPage(page) {
      this.$emit('getDataByPage', page);
    },
    paginate(n) {
      this.$emit('paginate', n);
    },
    last() {
      this.$emit('last', '');
    },
    goToFirst() {
      this.$emit('getDataByPage', 1);
    },

    goToLast() {
      this.$emit('getDataByPage', this.lastPage);
    },

  }
}
</script>

<style lang="sass" scoped>
@import "../../../sass/pagination.sass"

.disabled
  pointer-events: none
  opacity: 0.5
  cursor: not-allowed

.current-page
  font-weight: bold
  text-decoration: underline  
  color: black
</style>
